import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { FeatureFlag } from '@revelio/core';

import { useUnleashUserFlagsReady } from '../unleash-flags/unleash-flags';
import { useUnleashFlag } from '../unleash-flags/use-unleash-flag';
import {
  getTopNOverride,
  isTopNOverrideReloadPending,
  isTopNOverrideSuppressed,
  reloadPage,
  setTopNOverride,
  setTopNOverrideSuppressed,
} from './top-n-override-exchange';

export const useTopNOverrideFlagGuard = () => {
  const isEnabled = useUnleashFlag(FeatureFlag.CompositionTopNOverride);
  const areFlagsReady = useUnleashUserFlagsReady();

  useEffect(() => {
    if (!areFlagsReady) return;
    if (isEnabled) {
      if (!isTopNOverrideSuppressed()) return;
      setTopNOverrideSuppressed(false);
      // Cached results were fetched without the override that just came back.
      if (getTopNOverride() !== null) reloadPage();
      return;
    }
    if (getTopNOverride() === null) return;
    setTopNOverride(null);
    if (getTopNOverride() === null) {
      reloadPage();
      return;
    }
    setTopNOverrideSuppressed(true);
  }, [areFlagsReady, isEnabled]);

  const { pathname } = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: re-check on every navigation
  useEffect(() => {
    if (isTopNOverrideReloadPending()) reloadPage();
  }, [pathname]);
};
